import { JobItem } from "@/type/commonTypes";

export const jobsData: JobItem[] = [
  // {
  //   title: "Jr. PHP Developer",
  //   department: "ENGINEERING",
  //   location: "Udaipur, Rajasthan",
  //   description:
  //     "You'll be working on the systems that power SIPs, redemptions, and KYC for thousands of investors - not a toy CRUD app. We want someone early in their career who's hungry to learn how a real financial platform is built and hardened.",
  //   responsibilities: [
  //     "Up to 2 years of experience with PHP (Laravel or CakePHP) and MySQL.",
  //     "Help build and maintain APIs that talk to RTAs, payment gateways, and KYC providers.",
  //     "Fix bugs across the transaction and order-processing flow without breaking what already works.",
  //     "Learn to write code that holds up under audit - clean, logged, and easy for someone else to trace.",
  //   ],
  // },
  // {
  //   title: "SEO Manager",
  //   department: "MARKETING",
  //   location: "Udaipur, Rajasthan",
  //   description:
  //     "Mutual fund search terms are some of the most competitive in India, and trust matters as much as ranking. We need someone who can grow our organic traffic while keeping every page compliant and genuinely useful to someone deciding where to put their money.",
  //   responsibilities: [
  //     "1+ years running SEO for a content-heavy or finance-related website.",
  //     "Own on-page, technical, and off-page SEO for mysiponline.com, including Core Web Vitals and site architecture.",
  //     "Work with the content team to target fund, tax, and investment-planning keywords without sounding like a template.",
  //     "Track rankings, traffic, and conversions, and know when a drop is an algorithm update versus an actual problem.",
  //   ],
  // },
  {
    title: "Content Writer",
    department: "CONTENT & RESEARCH",
    location: "Udaipur, Rajasthan",
    description:
      "You'll write about mutual funds, taxes, and financial planning for people who are trusting us to get it right. We need someone who can explain SIPs and capital gains as clearly as they'd explain it to a friend, not a compliance document.",
    responsibilities: [
      "1+ years writing financial or investment content, ideally for a fund house, broker, or fintech platform.",
      "Turn AMFI data, fund factsheets, and market updates into articles investors will actually read.",
      "Keep every claim accurate and dated - this is money, not lifestyle content.",
      "Work with SEO and design to make sure the writing performs, not just reads well.",
    ],
  },
  {
    title: "Financial Consultant",
    department: "ADVISORY",
    location: "Udaipur, Rajasthan",
    description:
      "This is an entry point into wealth advisory, not a call-center job. You'll be the first real conversation many investors have about their money, so we care more about how you listen than how fast you can pitch.",
    responsibilities: [
      "Freshers welcome - a background in finance, commerce, or economics is a plus.",
      "Understand a client's goals and risk appetite before recommending any fund or SIP.",
      "Learn to explain concepts like asset allocation, tax-saving funds, and SIP step-ups in plain language.",
      "Follow SEBI/AMFI advisory norms in every client interaction from day one.",
    ],
  },
  {
    title: "Social Media Executive",
    department: "MARKETING",
    location: "Udaipur, Rajasthan",
    description:
      "Finance content on social media is either boring or misleading, and we want neither. You'll help us post things about SIPs and markets that people actually stop scrolling for, without oversimplifying to the point of being wrong.",
    responsibilities: [
      "Freshers welcome - show us a portfolio or personal account where you've grown an audience.",
      "Plan and post content across Instagram, LinkedIn, and YouTube around funds, markets, and money habits.",
      "Turn research team insights into reels, carousels, and short videos non-finance people will understand.",
      "Track what's working and double down on it instead of guessing every week.",
    ],
  },
  {
    title: "Relationship Manager",
    department: "SALES",
    location: "Udaipur, Rajasthan",
    description:
      "Our investors stay with us for years, sometimes decades, and a lot of that comes down to who's on the other end of the call. We're looking for someone who can build that kind of long-term trust, not just close a SIP and move on.",
    responsibilities: [
      "1-2 years in sales or client servicing, ideally in BFSI, banking, or insurance.",
      "Manage a book of investors - onboarding, portfolio reviews, and renewals.",
      "Spot when a client's goals have changed and proactively suggest a portfolio review.",
      "Keep KYC, folio, and transaction records accurate and audit-ready.",
    ],
  },
];

export const defaultRoleDescriptions: Record<string, string> = jobsData.reduce(
  (acc, job) => {
    if (job.description) {
      acc[job.title] = job.description;
    }
    return acc;
  },
  {} as Record<string, string>,
);

export const defaultRoleResponsibilities: Record<string, string[]> =
  jobsData.reduce(
    (acc, job) => {
      if (job.responsibilities) {
        acc[job.title] = job.responsibilities;
      }
      return acc;
    },
    {} as Record<string, string[]>,
  );

export const fallbackResponsibilities: string[] = [
  "Take ownership of core responsibilities and deliver high-impact results.",
  "Collaborate across cross-functional teams to drive innovation and excellence.",
  "Maintain high quality standards, data integrity, and industry compliance.",
  "Continuously learn, iterate, and contribute to company milestones.",
];

export { jobsData as dummyJobs };
